import script from "./CarouselView.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselView.vue?vue&type=script&setup=true&lang=js"

import "./CarouselView.vue?vue&type=style&index=0&id=61c89831&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c89831"]])

export default __exports__